import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const reloadAgenda = () => {
  eventBus.$on('reloadAgenda', () => {
    const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
    apiConnector()
      .get(`${baseUrl}/domestic/agenda.js`, {
        params: {
          agenda_search: true,
        },
      })
      .then((response) => eval(response.data));
  });
};

const init = () => {
  try {
    reloadAgenda();
  } catch (e) {
    errorManager(e);
  }
};

window.ReloadAgenda = {
  init: init,
};
